export const CONTENT_WIDTH = Object.freeze({
	NARROW: 'narrow',
	NORMAL: 'normal',
})
